import Import from './import';
import Menu from './menu';
import MenuEditHistory from './menu-edit-history';
import Modifiers from './modifiers';
import SmartPricing from './smart-pricing';
import SoldOutItems from './sold-out-items';
import MasterOverview from './MasterOverview';

export default {
  Import,
  Menu,
  MenuEditHistory,
  Modifiers,
  SmartPricing,
  SoldOutItems,
  MasterOverview,
};
